import React from 'react';
import { I18n } from 'react-redux-i18n';
import PropTypes from 'prop-types';
import MultiselectFilter from 'components/Filter/MultiselectFilter';
import FlexGroup from 'components/FlexGroup';
import DatetimeRangeFilter from 'components/Filter/DatetimeRangeFilter';
import moment from 'moment';

import {
    CLAIM_TYPE_GROUP,

    FEE_TYPE_ALL_GROUP,

    FEE_STATUS_UNPAID,
    FEE_STATUS_FAILED,
    FEE_STATUS_PAID,
    FEE_STATUS_REFUND,
    FEE_STATUS_CANCEL,
    FEE_STATUS_PROCESSING,
    FEE_STATUS_PROCESS_SUCCESS,
    FEE_STATUS_PROCESS_FAILED,
    FEE_STATUS_ABSORBED_BY_INTR,

    FEE_SUBTYPE_VIOLATE_ILLEGAL_PARKING,
    FEE_SUBTYPE_VIOLATE_NON_ILLEGAL_PARKING,
    FEE_SUBTYPE_CHARGE_PRIVATE_PARKING,
    FEE_SUBTYPE_CHARGE_TOWING_YARD,
    FEE_SUBTYPE_CHARGE_OTHERS_NO_INVOICE,
    FEE_SUBTYPE_TOWING_ILLEGAL_PARKING,
    FEE_SUBTYPE_TOWING_TOWING_YARD,
    FEE_SUBTYPE_TOWING_OUTSIDE,
    FEE_SUBTYPE_TOWING_TRAFFIC_ACCIDENT,
    FEE_SUBTYPE_TOWING_DRUNK_DRIVING,
    FEE_SUBTYPE_REPAIR_CAR_DAMAGE,
    FEE_SUBTYPE_REPAIR_SUSPECTED_DAMAGE,
    FEE_SUBTYPE_OTHERS_INVOICE_RETRIEVAL,
    FEE_SUBTYPE_OTHERS_INVOICE_DENY_TWICE,
    FEE_SUBTYPE_OTHERS_INVOICE_OP_LOST,
    FEE_SUBTYPE_OTHERS_INVOICE_OTHERS,
} from 'constants/additional-fee';

export const SEARCH = 'search';
export const SEARCH_BY_RENTAL = 'rental_id';
export const SEARCH_BY_CUSTOMER = 'customer_id';
export const SEARCH_BY_PLATE = 'plate_no';
export const SEARCH_BY_FINE_NO = 'ticket_no';
export const CLAIM_TYPE = 'claim_type';
export const FEE_TYPE = 'fee_type';
export const FEE_SUBTYPE = 'subtype';
export const STATUS = 'status';
export const CREATE_TIME = 'create_time';
export const defaultRange = [90, 'days'];

export const getClaimTypeOptions = () => [
    ...CLAIM_TYPE_GROUP,
].map(
    value => ({
        text: I18n.t(`additional_fee.claim_type_map.${ value }`),
        value,
    })
);

export const getFeeTypeOptions = () => [
    ...FEE_TYPE_ALL_GROUP,
].map(
    value => ({
        text: I18n.t(`additional_fee.fee_type_map.${ value }`),
        value,
    })
);

export const getFeeStatusOptions = () => [
    FEE_STATUS_UNPAID,
    FEE_STATUS_FAILED,
    FEE_STATUS_PAID,
    FEE_STATUS_REFUND,
    FEE_STATUS_CANCEL,
    FEE_STATUS_PROCESSING,
    FEE_STATUS_PROCESS_SUCCESS,
    FEE_STATUS_PROCESS_FAILED,
    FEE_STATUS_ABSORBED_BY_INTR,
].map(
    value => ({
        text: I18n.t(`additional_fee.fee_status_map.${ value }`),
        value,
    })
);

export const getSubtypeOptions = () => [
    FEE_SUBTYPE_VIOLATE_ILLEGAL_PARKING,
    FEE_SUBTYPE_VIOLATE_NON_ILLEGAL_PARKING,
    FEE_SUBTYPE_CHARGE_PRIVATE_PARKING,
    FEE_SUBTYPE_CHARGE_TOWING_YARD,
    FEE_SUBTYPE_CHARGE_OTHERS_NO_INVOICE,
    FEE_SUBTYPE_TOWING_ILLEGAL_PARKING,
    FEE_SUBTYPE_TOWING_TOWING_YARD,
    FEE_SUBTYPE_TOWING_OUTSIDE,
    FEE_SUBTYPE_TOWING_TRAFFIC_ACCIDENT,
    FEE_SUBTYPE_TOWING_DRUNK_DRIVING,
    FEE_SUBTYPE_REPAIR_CAR_DAMAGE,
    FEE_SUBTYPE_REPAIR_SUSPECTED_DAMAGE,
    FEE_SUBTYPE_OTHERS_INVOICE_RETRIEVAL,
    FEE_SUBTYPE_OTHERS_INVOICE_DENY_TWICE,
    FEE_SUBTYPE_OTHERS_INVOICE_OP_LOST,
    FEE_SUBTYPE_OTHERS_INVOICE_OTHERS,
].map(
    value => ({
        text: I18n.t(`additional_fee.fee_subtype_map.${ value }`),
        value,
    })
);

export const getDefaultPeriod = () => {
    return {
        start: moment().subtract(...defaultRange).format('YYYY-MM-DD'),
        end: moment().startOf('day').add(1, 'd'),
    };
};

const AdditionalFeeFilter = ({
    applyFilter,
    appliedDateRange,
    filter,
    excludeList,
    isForcedOpen,
    disabled,
}) => {


    return (
        <FlexGroup start className="choice-group-field">
            <section className="filters">
                {
                    excludeList.length && excludeList.includes(CLAIM_TYPE) ? null : (
                        <MultiselectFilter
                            title={ I18n.t('additional_fee.claim_type') }
                            options={ getClaimTypeOptions() }
                            defaultSelected={ filter[CLAIM_TYPE] }
                            onChange={ applyFilter(CLAIM_TYPE) }
                            isForcedOpen={ isForcedOpen }
                            disabled={ disabled }
                        />
                    )
                }
                {
                    excludeList.length && excludeList.includes(FEE_TYPE) ? null : (
                        <MultiselectFilter
                            title={ I18n.t('additional_fee.fee_type') }
                            options={ getFeeTypeOptions() }
                            defaultSelected={ filter[FEE_TYPE] }
                            onChange={ applyFilter(FEE_TYPE) }
                            isForcedOpen={ isForcedOpen }
                            disabled={ disabled }
                        />
                    )
                }
                {
                    excludeList.length && excludeList.includes(FEE_SUBTYPE) ? null : (
                        <MultiselectFilter
                            title={ I18n.t('additional_fee.subtype') }
                            options={ getSubtypeOptions() }
                            defaultSelected={ filter[FEE_SUBTYPE] }
                            onChange={ applyFilter(FEE_SUBTYPE) }
                            isForcedOpen={ isForcedOpen }
                            disabled={ disabled }
                        />
                    )
                }
                {
                    excludeList.length && excludeList.includes(STATUS) ? null : (
                        <MultiselectFilter
                            title={ I18n.t('additional_fee.status') }
                            options={ getFeeStatusOptions() }
                            defaultSelected={ filter[STATUS] }
                            onChange={ applyFilter(STATUS) }
                            isForcedOpen={ isForcedOpen }
                            disabled={ disabled }
                        />
                    )
                }
                {
                    excludeList.length && excludeList.includes(CREATE_TIME) ? null : (
                        <DatetimeRangeFilter
                            range={ defaultRange }
                            title={ I18n.t('customer.create_time') }
                            defaultFrom={ filter.create_from }
                            defaultTo={ filter.create_to }
                            onApply={ applyFilter(CREATE_TIME) }
                            applied={ appliedDateRange }
                        />
                    )
                }
            </section>
        </FlexGroup>
    );
};

AdditionalFeeFilter.propTypes = {
    applyFilter: PropTypes.func,
    appliedDateRange: PropTypes.bool,
    filter: PropTypes.shape(),
    excludeList: PropTypes.arrayOf(PropTypes.oneOf([
        CLAIM_TYPE,
        FEE_TYPE,
        FEE_SUBTYPE,
        STATUS,
        CREATE_TIME,
    ])),
    isForcedOpen: PropTypes.bool,
    disabled: PropTypes.bool,
};

AdditionalFeeFilter.defaultProps = {
    applyFilter: () => {},
    appliedDateRange: false,
    filter: {},
    excludeList: [],
    isForcedOpen: false,
    disabled: false,
};

export default AdditionalFeeFilter;
